import(/* webpackMode: "eager" */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\ayurvedic-treatment-disc-bulge-kerala\\Faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\ayurvedic-treatment-disc-bulge-kerala\\treatments.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\ayurvedic-treatment-in-kerala\\form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\components\\home\\Treatmentslist.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\components\\layout\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\components\\layout\\Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\components\\layout\\Insurance.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\components\\layout\\LatestDocVlog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\components\\layout\\recognizedby.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\components\\Ourdoctors.tsx");
